'use strict';
angular.module('more.ui.form', []);
